import { localization } from '@ocean/configs'
import { namespace as elearningDetailsNamespace } from 'modules/activityDetails/ElearningDetails/localization'
import { namespace as rapidElearningDetailsNamespace } from 'modules/activityDetails/RapidElearningDetails/localization'
import { namespace as surveyDetailsNamespace } from 'modules/activityDetails/SurveyDetails/localization'
import { namespace } from 'modules/virtualClassrooms/common/localization'
import {
  EventTaskRequirementType,
  VirtualEventTaskType,
  CreatorFormAssessmentCriteriaParams,
  CreatorFormAssessmentSelectParams,
  Assessment,
} from 'modules/virtualClassrooms/manager/EventDetails/types/tasksAndResources'

const { i18n } = localization

const I18_PATH = `${namespace}:manager.eventDetails.tasksAndResources.eventRelatedTasks.taskCreator`
const I18_PATH_SURVEY_DETAILS = `${surveyDetailsNamespace}:surveyDetails`
const I18_PATH_ELEARNING_DETAILS = `${elearningDetailsNamespace}:elearningDetails`
const I18_PATH_RAPID_ELEARNING_DETAILS = `${rapidElearningDetailsNamespace}:rapidElearningDetails`

const TEST_CRITERION_1_PARAMS: (keyof CreatorFormAssessmentSelectParams | keyof Assessment)[] = [
  'testId', // testDefinitionId
  'departmentId',
  'testDefinitionId',
]
const TEST_CRITERION_2_PARAMS: (keyof CreatorFormAssessmentSelectParams | keyof Assessment)[] = [
  'levelId', // responsibilityLevelId
  'responsibilityLevelId',
  'detailedSubjectId',
]
const TEST_CRITERION_3_PARAMS: (keyof CreatorFormAssessmentSelectParams)[] = ['vesselTypeId']

class TasksAndResourcesUtils {
  getRequirementTypeName(requiredType: EventTaskRequirementType) {
    const REQUIREMENT_TYPE_NAMES = {
      [EventTaskRequirementType.Required]: i18n.t(`${I18_PATH}.requirementType.required`),
      [EventTaskRequirementType.Recommended]: i18n.t(`${I18_PATH}.requirementType.recommended`),
    }
    return REQUIREMENT_TYPE_NAMES[requiredType]
  }

  getRequirementTypes() {
    const REQUIREMENT_TYPES = [
      {
        value: EventTaskRequirementType.Required,
        label: this.getRequirementTypeName(EventTaskRequirementType.Required),
      },
      {
        value: EventTaskRequirementType.Recommended,
        label: this.getRequirementTypeName(EventTaskRequirementType.Recommended),
      },
    ]
    return REQUIREMENT_TYPES
  }

  getVirtualEventTaskTypeName(type: VirtualEventTaskType) {
    const VIRTUAL_EVENT_TASK_TYPE_NAMES = {
      [VirtualEventTaskType.Url]: i18n.t(`${I18_PATH}.tasks.readingUrl.readingUrl`),
      [VirtualEventTaskType.File]: i18n.t(`${I18_PATH}.tasks.readingPdf.readingPdf`),
      [VirtualEventTaskType.Survey]: i18n.t(`${I18_PATH_SURVEY_DETAILS}.title`),
      [VirtualEventTaskType.Elearning]: i18n.t(`${I18_PATH_ELEARNING_DETAILS}.title`),
      [VirtualEventTaskType.RapidElearning]: i18n.t(`${I18_PATH_RAPID_ELEARNING_DETAILS}.title`),
      [VirtualEventTaskType.Assessment]: i18n.t(`${I18_PATH}.tasks.assessment.assessment`),
    }
    return VIRTUAL_EVENT_TASK_TYPE_NAMES[type]
  }

  getTestCriteriaIds(
    testCriterionParams: Partial<
      Record<keyof CreatorFormAssessmentSelectParams | keyof Assessment, any>
    >
  ): Partial<Record<keyof CreatorFormAssessmentCriteriaParams, string>> {
    return Object.keys(testCriterionParams).reduce((result, paramName) => {
      const paramKey = paramName as keyof CreatorFormAssessmentSelectParams | keyof Assessment
      if (!testCriterionParams[paramKey]) return result
      if (
        TEST_CRITERION_1_PARAMS.includes(paramKey) &&
        (!result.testCriteriaId1 || paramKey !== 'testId')
      )
        result.testCriteriaId1 = testCriterionParams[paramKey]
      if (TEST_CRITERION_2_PARAMS.includes(paramKey))
        result.testCriteriaId2 = testCriterionParams[paramKey]
      if (TEST_CRITERION_3_PARAMS.includes(paramKey as keyof CreatorFormAssessmentSelectParams))
        result.testCriteriaId3 = testCriterionParams[paramKey]
      return result
    }, {} as Partial<Record<keyof CreatorFormAssessmentCriteriaParams, string>>)
  }
}

export default new TasksAndResourcesUtils()
